<form class="o-form c-themes-filters u-margin-bottom-large"
      [formGroup]="filterForm"
      (ngSubmit)="applyFilters()">

  <section class="c-themes-filters__section u-margin-bottom-small">
    <h2 class="c-accordion-aside__title gamma">
      Filtrar temas
    </h2>

    <mat-form-field *ngIf="filterForm.get('texto')"
                    class="o-form__control c-themes-filters__control"
                    floatLabel="always" appearance="outline">
      <mat-label>Buscar por:</mat-label>

      <input matInput placeholder="" formControlName="texto">
    </mat-form-field>


    <mat-form-field *ngIf="typeFilterCtrl"
                    class="o-form__control c-themes-filters__control"
                    floatLabel="always" appearance="outline">
      <mat-label>Tipo</mat-label>

      <mat-select placeholder="Todos" formControlName="tipoTema">

        <mat-option [value]="null">Todos</mat-option>
        <mat-option [value]="'ESCOLA'">Escola</mat-option>
        <mat-option [value]="'RED1000'">Red1000</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="u-margin-bottom" *ngIf="filterForm.get('ativo')">
      <mat-slide-toggle
        labelPosition="after"
        color="accent"
        [(ngModel)]="filterByActive"
        [ngModelOptions]="{ standalone: true }">

        Filtrar por atividade
      </mat-slide-toggle>

      <mat-radio-group
        *ngIf="filterByActive"
        formControlName="ativo"
        aria-label="selecione"
        class="u-padding-top-small"
        style="display: block">

        <mat-radio-button [value]="true" class="u-margin-right">ativos</mat-radio-button>
        <mat-radio-button [value]="false" class="u-margin-right">inativos</mat-radio-button>
      </mat-radio-group>
    </div>

    <div *ngIf="filterForm.get('video')"
         class="u-margin-bottom-large">

      <mat-slide-toggle
        labelPosition="after"
        color="accent"
        [(ngModel)]="filterByVideo"
        [ngModelOptions]="{ standalone: true }">

        Filtrar por video
      </mat-slide-toggle>

      <mat-radio-group
        *ngIf="filterByVideo"
        formControlName="video"
        aria-label="selecione"
        class="u-padding-top-small"
        style="display: block">

        <mat-radio-button [value]="true" class="u-margin-right">com video</mat-radio-button>
        <mat-radio-button [value]="false" class="u-margin-right">sem video</mat-radio-button>
      </mat-radio-group>
    </div>

    <mat-divider></mat-divider>
  </section>


  <mat-accordion class="c-accordion-aside" [multi]="true">

    <section *ngIf="categoriesFilterForm" class="c-themes-filters__section">
      <mat-expansion-panel hideToggle
                           class="mat-elevation-z0 c-accordion-aside__panel"
                           [expanded]="expanded ? !(isMobile$ | async) : false">

        <mat-expansion-panel-header class="c-accordion-aside__header">
          <h3 class="c-accordion-aside__title u-margin-none">
            Modelo de correção
          </h3>

          <span class="c-accordion-icon"></span>
        </mat-expansion-panel-header>

        <p *ngFor="let category of categoriesFilterForm.controls; let i = index; let last = last"
           formArrayName="listCategoria"
           class="u-margin-left-small"
           [class.u-margin-bottom-large]="last">

          <ng-container [formGroupName]="i">
            <mat-checkbox formControlName="value">
              {{ category.get('label').value }}

              <small class="c-pill u-margin-left-tiny">
                {{ category.get('numberLabel').value }}
              </small>
            </mat-checkbox>
          </ng-container>
        </p>

      </mat-expansion-panel>
    </section>

    <section *ngIf="genresFilterForm" class="c-themes-filters__section">
      <mat-expansion-panel hideToggle
                           class="mat-elevation-z0 c-accordion-aside__panel"
                           [expanded]="expanded ? !(isMobile$ | async) : false">

        <mat-expansion-panel-header class="c-accordion-aside__header">
          <h3 class="c-accordion-aside__title u-margin-none">
            Gênero:
          </h3>

          <span class="c-accordion-icon"></span>
        </mat-expansion-panel-header>

        <p *ngFor="let category of genresFilterForm.controls; let i = index; let last = last"
           formArrayName="listGenero"
           class="u-margin-left-small"
           [class.u-margin-bottom-large]="last">

          <ng-container [formGroupName]="i">
            <mat-checkbox formControlName="value">
              {{ category.get('label').value }}

              <small class="c-pill u-margin-left-tiny">
                {{ category.get('numberLabel').value }}
              </small>
            </mat-checkbox>
          </ng-container>
        </p>
      </mat-expansion-panel>
    </section>

  </mat-accordion>
</form>
